interface Props {
  value: number; // 1..5
  max?: number;
  label?: string;
}

export function StarRating({ value, max = 5, label }: Props) {
  const v = Math.max(0, Math.min(max, Math.round(value)));
  return (
    <div className="flex items-center gap-2" aria-label={`評価 ${v}/${max}`}>
      <span className="text-gold-500 text-lg tracking-tight" aria-hidden>
        {'★'.repeat(v)}
        <span className="text-ink-300 dark:text-ink-700">{'☆'.repeat(max - v)}</span>
      </span>
      {label && <span className="pill">{label}</span>}
    </div>
  );
}
